import axios from 'axios';
import { useAuth } from '../../Provider/AuthProvider';
import { ApiResponse } from './Interfaces';

export const useSearch = () => {
    const { user, changeProduct, setBrands, setLoading } = useAuth();
    
    const searchByReference = async (reference: string) => {
        if (!reference?.trim()) {
            throw new Error('Search term is required');
        }

        setLoading(true);
        

        try {
            const savedCart = localStorage.getItem('cart');
            const cart = savedCart ? JSON.parse(savedCart) : { client: '', items: [], clientInfo: null };
            const clientId = cart?.clientInfo?.rowid;
            const data = {
                action: 'ref',
                entity: user.entity,
                reference: reference,
                clientId: clientId || "",
            }

            const response: any = await axios.post<ApiResponse>(
                'https://api.apapiecesauto.fr/apiV2/',
                data ,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${user.token}`,
                    }
                }
            );

            changeProduct(response.r || []);
            console.log(response.r,"ss")
            setBrands(response.brands || {});
            return response.default_warehouse;
        } catch (error) {
            console.error('Error fetching data:', error);
            if (axios.isAxiosError(error)) {
                console.error('Axios error details:', error.response?.data);
            }
            throw error;
        } finally {
            setLoading(false);
        }
    };

    return {
        searchByReference
    };
};